<template>
  <div v-if="description.description">
    <div class="description">
      <img class="description__avatar" :src="description.avatar" />
      <p>
        {{ description.description }}
      </p>
      <p v-if="description.additional">
        {{ description.additional }}
      </p>

      <button
        v-if="isMobile"
        @click="submit"
        :class="[
          'button',
          'button--white',
          { 'with-swords': character !== 'littlebigplanet' }
        ]"
      >
        <template v-if="character === 'littlebigplanet'">
          увеличить
        </template>
        <template v-else>
          <div class="swords" />
          АТАКОВАТЬ
          <div class="swords" />
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import getCharDescription from "../helpers/getCharDescription";

export default {
  props: ["character"],
  computed: {
    ...mapState(["isMobile"]),
    description() {
      return getCharDescription(this.character) || {};
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    }
  }
};
</script>

<style lang="scss" scoped>
.description {
  z-index: 999;
  position: relative;

  display: grid;
  text-align: center;
  padding: 42px 12px 30px;
  row-gap: 9px;

  width: 215px;

  border-radius: 5px;

  position: relative;

  color: $white;

  background-color: $primary;
  stroke: 1px solid #ffe1f3;

  &__avatar {
    position: absolute;
    justify-self: center;
    transform: translateY(-50%);
  }

  button.with-swords {
    padding: 0 12px;
    justify-content: space-between;
  }
}

.swords {
  height: 24px;
  width: 24px;
  display: inline-block;
  mask-image: url("../assets/img/modal/swords.svg");
  mask-position: center center;
  mask-repeat: no-repeat;
  mask-size: contain;
  background-color: $secondary;
}
</style>
